import React from 'react';
import i18n from 'I18n';

const WelcomeComponent = ({
  navBarConfig,
}) => {
  return (
    <div className="top-left-text-container subheading">
      <div className='top-left-text'>{i18n.t(navBarConfig.headerFirstMessage)}</div>
      {
        navBarConfig.headerSecondMessage && (
          <div className='top-left-text'>{i18n.t(navBarConfig.headerSecondMessage)}</div>
        )
      }
    </div>
  );
};

export default WelcomeComponent;
